import Cookies from "js-cookie";
import { useUser } from "../../contexts/UserContext";
import { LottieAnim } from "../LottieAnim";
import {
  ANIMATED_HOMEPAGE_ICONS,
  APP_DOMAIN,
  COOKIE_DOMAIN,
} from "../../config/env";

import AppButton from "../AppButton";
import ExitIcon from "../../assets/icons/exit";
import MenuIcon from "../../assets/icons/menu";
import { useIsMobile } from "../../hooks/useIsMobile";
import ServerTime from "../ServerTime";
import "./AppHeader.css";

type AppHeaderProps = {
  onToggleSidebar: () => void;
};

export default function AppHeader({ onToggleSidebar }: AppHeaderProps) {
  const isMobile = useIsMobile();
  const { user } = useUser();

  const handleLogout = () => {
    Cookies.remove("access_token", { domain: COOKIE_DOMAIN });
    window.location.href = `${APP_DOMAIN}`;
  };

  return (
    <header className="app-header">
      <ServerTime />
      <a href="/" aria-label="Logo" className="app-header-logo">
        <LottieAnim
          className="header-main-logo"
          name="logo"
          needsTrigger={!ANIMATED_HOMEPAGE_ICONS}
          isstopped={!ANIMATED_HOMEPAGE_ICONS ? "true" : undefined}
        />
        <h1>Partner</h1>
      </a>
      {user?.avatar?.url && (
        <div className="app-header-actions">
          <AppButton variant="light-2" ariaLabel="Avatar" noHover>
            <div className="app-header-actions__user">
              <img
                src={user?.avatar?.url}
                alt="User Avatar"
                className="app-header-avatar"
              />
              {!isMobile && <span>{user?.display_name}</span>}
            </div>
          </AppButton>
          {!isMobile ? (
            <AppButton
              variant="light"
              prefix={<ExitIcon />}
              ariaLabel="Log out"
              onClick={handleLogout}
            ></AppButton>
          ) : (
            <button
              className="burger-btn"
              onClick={onToggleSidebar}
              aria-label="Toggle sidebar"
            >
              <MenuIcon />
            </button>
          )}
        </div>
      )}
    </header>
  );
}
